import React from 'react';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './Categories1.css';
import Breadcrumb from './Breadcrumb';
import Swal from 'sweetalert2';

function ProductListFound({addToCart}) {

    /*const [infoProduct, setInfoProduct] = useState('');
    const [newPrice, setNewPrice] = useState(0);
    const [cantidad, setCantidad] = useState(1);*/

    const [textsearch, setTextSearch] = useState('');
    const [tagsearch, setTagSearch] = useState('');

    const [objeto, setObjeto] = useState({});

    const [product_list, setProductList] = useState([]);

    const [tBusqueda, setTBusqueda] = useState('');
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [hitsPerPage, setHitsPerPage] = useState(0);

    useEffect( () => {
        
        if ( localStorage.getItem('valueBarSearch') !== null ) {
            
            let obj = JSON.parse(localStorage.getItem('valueBarSearch'));
            
            findProducts(obj);
            
            localStorage.removeItem("valueBarSearch");
            

        } else {

            //alert('No hay información, serás reedirigido a la lista de tickets');
            Swal.fire('Upss', 'No hay información sobre el producto, serás reedirigido a la lista de productos dess', 'info');
            window.location.href = '/';

        }

    }, []);

    const findProducts = (obj) => {
        //let _token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');//obtenemos el token del form
        let url = '/api/get_products_search';

        const formData = new FormData();
        formData.append('text_search', obj.textsearch);
        formData.append('f_tag', obj.tagsearch);
        formData.append('num_page', obj.page);
        formData.append('h_p_p', obj.h_p_p);

        //setProductList([]);

        fetch(url, {
            method: "POST",
            headers: {
                //'X-CSRF-TOKEN': _token //asignamos el token frm a los headers
            },
            body: formData

        }).then ( response => response.json())
        .then ( data => {

            if (data.response == 'success') {

                setProductList(data.data);
                setTotal(data.total);
                setPage(data.page);
                setTotalPages(data.total_pages);
                setHitsPerPage(obj.h_p_p);

                setTextSearch(obj.textsearch);
                setTagSearch(obj.tagsearch);

                setObjeto(obj);

                setTBusqueda(obj.tagsearch != '' ? 'tag' : 'text');
            }
            if (data.response == 'info') {
                Swal.fire('Upss', data.message, 'info');
            }


        }).catch(error =>{
            console.error(error);
        });
    }

    const goToProductsSubcategory = (idsubcategory, nameSubcategory) => {
        //window.open('/category_products/'+idcategory);
        window.location.href = '/category_products/'+idsubcategory;
    }

    const changeSelectPresentation = (e) => {

        const option = e.target.options[e.target.selectedIndex];
        // Acceder a data-type u otro data-*
        const max = option.getAttribute('data-max');

        const value = e.target.value;

        let infp = infoProduct;

        //let gram = max / 1000;//de gramos a kilogramos
        let kilo = max;//kilogramos

        let preciop = parseFloat(infoProduct.price1).toFixed(2);
        let nuevo_precio = kilo * preciop;

        infp.subtotal = value == '' ? infp.price1 : nuevo_precio;

        setInfoProduct(infp);

        setNewPrice(nuevo_precio);
    }

    const handleInputCantidad = (e) => {

        let val = Number(e.target.value);

        let obj = infoProduct;

        let subtotal = newPrice > 0 ? newPrice * val : infoProduct.price1 * val;

        obj.quantity = val;
        obj.subtotal = subtotal;
        
        setCantidad(val);
        setInfoProduct(obj);
    }

    const clickIncDecQuantity = (incdec) => {

        let obj = infoProduct;
        let quant = Number(cantidad);

        if (incdec === 'increment') {
            quant++;
            
        } else {
            quant--;
        }

        let subtotal = newPrice > 0 ? newPrice * quant : obj.price1 * quant;
        obj.quantity = quant;
        obj.subtotal = subtotal;
        
        setCantidad(quant);
        setInfoProduct(obj);

    }

    const handleClickAddItem = () => {

        let item = infoProduct;

        addToCart(item);
    }

    const handleSelectShowHits = (e) => {

        let val = e.target.value;
        
        let obj = {
            textsearch: objeto.textsearch,
            tagsearch: objeto.tagsearch,
            page: objeto.page,
            h_p_p: val
        };

        setHitsPerPage(val);

        findProducts(obj);
    }

    function Pagination() {
        
        const items = [];

        let tb = tBusqueda;

        for (let i = 0; i < totalPages; i++) {
                
            let fcs = <span className="page-numbers current" key={i}>{i + 1}</span>;
            let rest = <a className="page-numbers" onClick={()=>handleClickToPage(i)} key={i} style={{cursor:"pointer"}}>{i + 1}</a>
            
            if (i == page) {
                items.push(fcs);
            } else {
                items.push(rest);
            }
        }

        //return <>{items}</>;

        return (

            <nav className="kreen-pagination">
                {
                    page > 0 ?
                    <a className="prev page-numbers" onClick={()=>handleClickPrevPage()} style={{cursor:"pointer"}}>Previous</a>
                    :
                    null
                }
                {items}
                {
                    page + 1 < totalPages ?
                    <a className="next page-numbers" onClick={()=>handleClickNextPage()} style={{cursor:"pointer"}}>Next</a>
                    :
                    null
                }
            </nav>
        );

        /*if (tb == 'tag') {
            
            for (let i = 0; i < totalPages; i++) {
                
                let fcs = <span className="page-numbers current" key={i}>{i + 1}</span>;
                let rest = <a className="page-numbers" onClick={()=>handleClickToPage(i)} key={i} style={{cursor:"pointer"}}>{i + 1}</a>
                
                if (i == page) {
                    items.push(fcs);
                } else {
                    items.push(rest);
                }
            }

            //return <>{items}</>;

            return (

                <nav className="kreen-pagination">
                    {
                        page > 0 ?
                        <a className="prev page-numbers" onClick={()=>handleClickPrevPage()} style={{cursor:"pointer"}}>Previous</a>
                        :
                        null
                    }
                    {items}
                    {
                        page + 1 < totalPages ?
                        <a className="next page-numbers" onClick={()=>handleClickNextPage()} style={{cursor:"pointer"}}>Next</a>
                        :
                        null
                    }
                </nav>
            );
        } 
        
        if (tb == 'text') {

            for (let i = 1; i <= totalPages; i++) {
                
                let fcs = <span className="page-numbers current" key={i}>{i}</span>;
                let rest = <a className="page-numbers" onClick={()=>handleClickToPage(i)} key={i} style={{cursor:"pointer"}}>{i}</a>
                
                if (i == page) {
                    items.push(fcs);
                } else {
                    items.push(rest);
                }
            }

            //return <>{items}</>;

            return (

                <nav className="kreen-pagination">
                    {
                        page > 1 ?
                        <a className="prev page-numbers" onClick={()=>handleClickPrevPage()} style={{cursor:"pointer"}}>Previous</a>
                        :
                        null
                    }
                    {items}
                    {
                        page < totalPages ?
                        <a className="next page-numbers" onClick={()=>handleClickNextPage()} style={{cursor:"pointer"}}>Next</a>
                        :
                        null
                    }
                </nav>
            );
        }*/

        
        //return <>{items}</>;

        /*return (

            <nav className="kreen-pagination">
                {
                    page > 0 && page > 1 ?
                    <a className="prev page-numbers" onClick={()=>handleClickPrevPage()} style={{cursor:"pointer"}}>Previous</a>
                    :
                    null
                }
                {items}
                {
                    page < totalPages ?
                    <a className="next page-numbers" onClick={()=>handleClickNextPage()} style={{cursor:"pointer"}}>Next</a>
                    :
                    null
                }
            </nav>
        );*/



    }

    const handleClickToPage = (page) => {
        
        let val = page;

        let tb = tBusqueda;
        
        let obj = {
            textsearch: objeto.textsearch,
            tagsearch: objeto.tagsearch,
            page: val,
            h_p_p: hitsPerPage
        };

        //setHitsPerPage(val);

        setPage(val);

        findProducts(obj);

        /*if (tBusqueda == 'tag') {
                
                if (i == page + 1) {
                    items.push(fcs);
                } else {
                    items.push(rest);
                }
            } else {
                if (i == page) {
                    items.push(fcs);
                } else {
                    items.push(rest);
                }
            }*/

        let elmt = document.getElementById('products_find');

        //hacer que baje o haga scroll abajo para ver los productos
        if (elmt != null) {
            
            elmt.scrollIntoView();
        }
    }

    const handleClickNextPage = () => {
        let val = page + 1;

        let tb = tBusqueda;
        
        let obj = {
            textsearch: objeto.textsearch,
            tagsearch: objeto.tagsearch,
            page: val,
            h_p_p: hitsPerPage
        };

        //setHitsPerPage(val);

        setPage(val);

        findProducts(obj);

        /*if (tBusqueda == 'tag') {
                
                if (i == page + 1) {
                    items.push(fcs);
                } else {
                    items.push(rest);
                }
            } else {
                if (i == page) {
                    items.push(fcs);
                } else {
                    items.push(rest);
                }
            }*/

        let elmt = document.getElementById('products_find');

        //hacer que baje o haga scroll abajo para ver los productos
        if (elmt != null) {
            
            elmt.scrollIntoView();
        }
    }

    const handleClickPrevPage = () => {
        let val = page - 1;
        
        let obj = {
            textsearch: objeto.textsearch,
            tagsearch: objeto.tagsearch,
            page: val,
            h_p_p: hitsPerPage
        };

        setPage(val);

        findProducts(obj);

        let elmt = document.getElementById('products_find');

        //hacer que baje o haga scroll abajo para ver los productos
        if (elmt != null) {
            
            elmt.scrollIntoView();
        }
    }

    return (
        
        <div className="main-container shop-page no-sidebar">
            <div className="container">

                {
                    /*product_list.length == 0 ?
                    <div className='text-center'>
                        <h1 className='text-info'>Cargando información...</h1>
                    </div>
                    :
                    */
                }

                <div className="row">
                    <div className="main-content col-md-12">
                        <div className="shop-control shop-before-control">
                            <div className="grid-view-mode">
                                <form>
                                    <a href="shop.html" data-toggle="tooltip" data-placement="top"
                                    className="modes-mode mode-grid display-mode active" value="grid">
                                        <span className="button-inner">
                                            Shop Grid
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </span>
                                    </a>
                                    <a href="shop-list.html" data-toggle="tooltip" data-placement="top"
                                    className="modes-mode mode-list display-mode " value="list">
                                        <span className="button-inner">
                                            Shop List
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </span>
                                    </a>
                                </form>
                            </div>
                            {
                                /*
                                <form className="kreen-ordering" method="get">
                                    <select title="product_cat" name="orderby" className="orderby">
                                        <option value="menu_order" selected>Default sorting</option>
                                        <option value="popularity">Sort by popularity</option>
                                        <option value="rating">Sort by average rating</option>
                                        <option value="date">Sort by latest</option>
                                        <option value="price">Sort by price: low to high</option>
                                        <option value="price-desc">Sort by price: high to low</option>
                                    </select>
                                </form>
                                */
                            }
                            <form className="per-page-form">
                                <label>
                                    <select onChange={handleSelectShowHits} className="option-perpage">
                                        <option value="5">
                                            Ver 05
                                        </option>
                                        <option value="10" selected>
                                            Ver 10
                                        </option>
                                        <option value="12">
                                            Ver 12
                                        </option>
                                        <option value="15">
                                            Ver 15
                                        </option>
                                         <option value="20">
                                            Ver 20
                                        </option>
                                        {
                                            /*
                                            <option value="20">
                                                Ver todo
                                            </option>
                                            */
                                        }
                                    </select>
                                </label>
                            </form>
                        </div>
                        <div className=" auto-clear kreen-products">
                            <ul className="row products columns-3">
                                {
                                    product_list.map((prod, index) => {

                                        return (
                                            <li className="product-item wow fadeInUp product-item rows-space-30 col-bg-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-ts-6 style-01 post-28 product type-product status-publish has-post-thumbnail product_cat-light product_cat-chair product_cat-sofas product_tag-light product_tag-sock  instock sale featured shipping-taxable purchasable product-type-simple"
                                                data-wow-duration="1s" data-wow-delay="0ms" data-wow="fadeInUp" key={index}>
                                                <div className="product-inner tooltip-left">
                                                    <div className="product-thumb">
                                                        <a className="thumb-link" href={`/product_detail/`+prod.dessProductId}>
                                                            {
                                                                prod.image != null ?
                                                                <img className="img-responsive"
                                                                    src={prod.image}
                                                                    alt={prod.name} width="600" height="778" />
                                                                :
                                                                <img className="img-responsive"
                                                                    src="../assets/images/defaults/default-image-product.jpg"
                                                                    alt={prod.name} width="600" height="778" />
                                                            }
                                                        </a>
                                                        {
                                                            /*
                                                            <div className="flash">
                                                                <span className="onsale"><span className="number">-14%</span></span>
                                                                <span className="onnew"><span className="text">New</span></span>
                                                            </div>
                                                            <a href="#" className="button yith-wcqv-button" data-product_id="24">Quick View</a>
                                                            <div className="group-button">
                                                                <div className="yith-wcwl-add-to-wishlist">
                                                                    <div className="yith-wcwl-add-button show">
                                                                        <a href="#" className="add_to_wishlist">Add to Wishlist</a>
                                                                    </div>
                                                                </div>
                                                                <div className="kreen product compare-button">
                                                                    <a href="#" className="compare button">Compare</a>
                                                                </div>
                                                                <a href="#" className="button yith-wcqv-button">Quick View</a>
                                                                <div className="add-to-cart">
                                                                    <a href="#" className="button product_type_simple add_to_cart_button">Add to
                                                                        cart</a>
                                                                </div>
                                                            </div>
                                                            */
                                                        }
                                                    </div>
                                                    <div className="product-info equal-elem">
                                                        <h3 className="product-name product_title">
                                                            <a href="#">{prod.name}</a>
                                                        </h3>
                                                        {
                                                            /*
                                                            <div className="rating-wapper ">
                                                                <div className="star-rating"><span style={{width:"100%"}}>Rated <strong className="rating">5.00</strong> out of 5</span>
                                                                </div>
                                                                <span className="review">(1)</span>
                                                            </div>
                                                            */
                                                        }
                                                        <span className="price">
                                                            {
                                                                /*
                                                                <del><span className="kreen-Price-amount amount"><span
                                                                    className="kreen-Price-currencySymbol">$</span>138.00</span>
                                                                </del> 
                                                                <ins><span
                                                                    className="kreen-Price-amount amount"><span
                                                                    className="kreen-Price-currencySymbol">$</span>119.00</span>
                                                                </ins>
                                                                */
                                                            }
                                                            <ins><span
                                                                className="kreen-Price-amount amount"><span
                                                                className="kreen-Price-currencySymbol">$</span>{parseFloat(prod.price).toFixed(2)}</span>
                                                            </ins>
                                                        </span>
                                                        <div className="kreen-product-details__short-description">
                                                            {
                                                                /*
                                                                <p>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac
                                                                    turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget,
                                                                    tempor sit amet, ante.</p>
                                                                <ul>
                                                                    <li>Water-resistant fabric with soft lycra detailing inside</li>
                                                                    <li>CLean zip-front, and three piece hood</li>
                                                                    <li>Subtle branding and diagonal panel detail</li>
                                                                </ul>
                                                                */
                                                            }
                                                            <p>{prod.description}</p>
                                                            <ul>
                                                                <li>Categoria: {prod.category}</li>
                                                                <li>Subcategoria: {prod.subcategory}</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="group-button">
                                                        <div className="group-button-inner">
                                                            {
                                                                /*
                                                                <div className="yith-wcwl-add-to-wishlist">
                                                                    <div className="yith-wcwl-add-button show">
                                                                        <a href="#" className="add_to_wishlist">Add to Wishlist</a>
                                                                    </div>
                                                                </div>
                                                                <div className="kreen product compare-button">
                                                                    <a href="#" className="compare button">Compare</a>
                                                                </div>
                                                                <a href="#" className="button yith-wcqv-button">Quick View</a>
                                                                <div className="add-to-cart">
                                                                    <a href="#" className="button product_type_variable add_to_cart_button">Select
                                                                        options</a>
                                                                </div>
                                                                */
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        )

                                    })
                                }
                            </ul>
                        </div>
                        <div className="shop-control shop-after-control">
                            { tBusqueda != '' ? Pagination() : null }
                            <p className="kreen-result-count">Viendo 1–{hitsPerPage} de {total} resultados</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default ProductListFound;